/**
 * @generated SignedSource<<3ed500ad5fa4123c489d0a88e90d65b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "attachmentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uploadSuccessful"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "attachmentId",
        "variableName": "attachmentId"
      },
      {
        "kind": "Variable",
        "name": "parentId",
        "variableName": "parentId"
      },
      {
        "kind": "Variable",
        "name": "uploadSuccessful",
        "variableName": "uploadSuccessful"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Attachment",
    "kind": "LinkedField",
    "name": "attachments",
    "plural": true,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "Attachments"
      }
    ],
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Attachment",
    "kind": "LinkedField",
    "name": "attachments",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "size",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastModifiedTimestampUtc",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AttachmentCategory",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewAttachmentModalReportStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AttachmentReportUploadStatusPayload",
        "kind": "LinkedField",
        "name": "reportAttachmentUploadStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "parent",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "LegalContract",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "NetworkOwner",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "Network",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "Organization",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewAttachmentModalReportStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AttachmentReportUploadStatusPayload",
        "kind": "LinkedField",
        "name": "reportAttachmentUploadStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "parent",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "LegalContract",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "NetworkOwner",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "Network",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "Organization",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "52980db77f477afe056d3c3d459e745a",
    "id": null,
    "metadata": {},
    "name": "NewAttachmentModalReportStatusMutation",
    "operationKind": "mutation",
    "text": "mutation NewAttachmentModalReportStatusMutation(\n  $parentId: ID!\n  $attachmentId: ID!\n  $uploadSuccessful: Boolean!\n) {\n  reportAttachmentUploadStatus(input: {parentId: $parentId, attachmentId: $attachmentId, uploadSuccessful: $uploadSuccessful}) {\n    parent {\n      __typename\n      id\n      ... on LegalContract {\n        attachments {\n          ...Attachments\n          id\n        }\n      }\n      ... on NetworkOwner {\n        attachments {\n          ...Attachments\n          id\n        }\n      }\n      ... on Network {\n        attachments {\n          ...Attachments\n          id\n        }\n      }\n      ... on Organization {\n        attachments {\n          ...Attachments\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment Attachments on Attachment {\n  id\n  fileName\n  size\n  lastModifiedTimestampUtc\n  downloadUrl\n  category {\n    id\n    name\n  }\n}\n"
  }
};
})();

node.hash = "cec0b66a4425f9d8914c79f0c29a6e87";

export default node;
